import React, { useEffect, useState } from "react";
import { Typography, FormControlLabel, FormControl, Checkbox, RadioGroup } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";

export default function StepOne(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

        useEffect(() => {
            if (props.datas.location && Object.keys(props.datas.location).length >= 1) {
                buttons[1].disabled = false;
            } else {
                buttons[1].disabled = true;
            }
            setButtons([...buttons]);
        }, [props.datas]);

    function handleChange(e){
        let datas = Object.assign({}, props.datas);
        if(!datas.location){
            datas.location = [];
        }
        let filtered = datas.location.filter( data => data != e.target.value);
        if(e.target.checked){
            filtered.push(e.target.value);
        }
        datas.location = filtered;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
                Où exercer vous votre activité ? (Plusieurs réponses possibles)
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="gender"
                        defaultValue="public"
                        name="radio-buttons-group">
                        <FormControlLabel value="Centre ville de Montpellier" control={<Checkbox name='location' onChange={(e) => handleChange(e)}/>} label="Centre ville de Montpellier"/>
                        <FormControlLabel value="Dans les quartier en périphérie du centre" control={<Checkbox name='location' onChange={(e) => handleChange(e)}/>} label="Dans les quartier en périphérie du centre" />
                        <FormControlLabel value="En dehors de la ville (zone urbaine)" control={<Checkbox name='location' onChange={(e) => handleChange(e)}/>} label="En dehors de la ville (zone urbaine)" />
                        <FormControlLabel value="En dehors de la ville (zone rurale)" control={<Checkbox name='location' onChange={(e) => handleChange(e)}/>} label="En dehors de la ville (zone rurale)" />
                        <FormControlLabel value="Sur le littoral" control={<Checkbox name='location' onChange={(e) => handleChange(e)}/>} label="Sur le littoral" />
                    </RadioGroup>
                </FormControl>
            </Typography>
            <ModalFooter buttons={buttons}/>
        </>
    )
}